export  const user_roles = {
  MERCHANT: 'merchant',
  ADMIN: 'admin',
  MARKETING: 'marketing',
}